import { render, staticRenderFns } from "./ExAvatar.vue?vue&type=template&id=3680a251&scoped=true"
import script from "./ExAvatar.vue?vue&type=script&lang=js"
export * from "./ExAvatar.vue?vue&type=script&lang=js"
import style0 from "./ExAvatar.vue?vue&type=style&index=0&id=3680a251&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3680a251",
  null
  
)

export default component.exports